var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoginProductLogotype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF005B",
    d: "M.5 0h48v48H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 9h2v30h-19V29h2v8h15V11h-15v6h-2V9h17zm-13 7h1v2h.5-.5v-1h1v1H25h1.5v1h1v1h1v2h.5-.5v-1h1v1H29h1.5v2h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-3h-14V18h14v-3h1v1zm8 5h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-2v-2h13v24h-13v-4h2v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-4z",
    fill: "#fff"
  })));
}

export default SvgLoginProductLogotype;